import { BlogPost } from "@/types/blog";
import { content } from "./content";
import koerperFuehrungHero from "@/assets/blog/koerper-fuehrung-hero.webp";

export const koerperFuehrungPost: BlogPost = {
  title: "Wenn der Körper die Führung übernimmt",
  metaTitle: "Körperintelligenz: Wenn der Körper führt",
  subtitle: "Warum Krankheit kein Versagen ist, sondern ein Signal, das klüger ist als jeder Terminkalender",
  excerpt: "Krankheit ist keine Schwäche, sondern ein hochpräzises neurobiologisches Signal. Erfahren Sie, wie Körperintelligenz zur wichtigsten Führungskompetenz wird und warum Regeneration keine Pause, sondern Leistungsgrundlage ist.",
  metaDescription: "Warum Krankheit kein Versagen ist: Vagusnerv, Psychoneuroimmunologie und Körperintelligenz lehren, mit dem Körper statt gegen ihn zu führen.",
  date: "23.10.2025",
  slug: "koerper-fuehrung",
  imageUrl: koerperFuehrungHero,
  category: "Neurobiologie",
  tags: ["Körperintelligenz", "Neurobiologie", "Selbstführung", "Regeneration", "Psychoneuroimmunologie", "Vagusnerv"],
  content,
  readingTime: 12
};
